<!-- 
Contents of the NOTICES tab of the levy collection provider page.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="breadcrumbs"
      :title="title" 
      :subtitle="subtitle" 
      user-guide-topic="levy-collection-providers"
      user-guide-section="notices"
    >
      <template v-slot:additional-nav>
        <div class="hidden-md-and-down" style="position:relative;top:-4px;">
          <v-btn 
            :to="`/providers/${providerId}`" flat small color="primary" 
            class="mt-0 mb-0 mr-0"
          >
            <v-icon class="mr-2">school</v-icon>
            Go to provider
          </v-btn>
          <our-next-previous-navigator
            :nav-url="`/levy-collections/${levyCollectionId}/providers/:id/notices`"
            :next-page-action="nextPageAction"
            :previous-page-action="previousPageAction"
            id-field="providerId"
            module="levyCollectionProviders"
            class="mb-0"
          />
        </div>
      </template>
      <template v-slot:prefix>
        <favourite-indicator :provider="provider" />
      </template>
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" />
      </template>
    </our-heading>
    <tabs :levy-collection-id="levyCollectionId" :provider-id="providerId">
      <notice-timeline-toggle 
        v-model="timeline" 
        :ascending.sync="ascending" 
        @changed="$refs.notices.refresh()"
      />
      <notice-timeline v-if="timeline" :levy-collection-id="levyCollectionId" :provider-id="providerId" :ascending="ascending" />
      <notice-listing 
        v-else 
        ref="notices" 
        :levy-collection-id="levyCollectionId" 
        :provider-id="providerId" 
        default-no-data-text="This provider does not have any notices yet."
        embedded
      />
    </tabs>
  </div>
</template>

<script>
import FavouriteIndicator from "@/components/levy-collection-providers/FavouriteIndicator.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import Tabs from "./Tabs.vue";
import NoticeTimeline from "@/components/notices/NoticeTimeline.vue";
import NoticeListing from "@/components/notices/NoticeListing.vue";
import NoticeTimelineToggle from "@/components/notices/NoticeTimelineToggle.vue";
import levyCollectionProviderMixins from "./mixins";

export default {
  name: "LevyCollectionProviderNotices",
  components: {
    FavouriteIndicator,
    LevyCollectionNavigator,
    Tabs,
    NoticeTimeline,
    NoticeTimelineToggle,
    NoticeListing
  },
  mixins: [levyCollectionProviderMixins],
  data() {
    return {
      timeline: true,
      ascending: true
    };
  }
};
</script>
